import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './app/App';
import { OverlayProvider } from './overlay';
import { installNativeDialogGuard } from './overlay/nativeDialogGuard';
// 英文与数字统一使用 JetBrains Mono。字体随包自托管（不请求 CDN），
// 只声明 unicode-range 子集，浏览器按需下载 latin / latin-ext。
import '@fontsource-variable/jetbrains-mono';
import './styles/index.css';

// 全站禁止浏览器原生弹窗：DEV 下把 alert/confirm/prompt 换成会大声报错的桩实现，
// 从而迫使所有交互都走统一的浮层系统。
installNativeDialogGuard();

const container = document.getElementById('root');
if (!container) throw new Error('缺少 #root 容器');

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <OverlayProvider>
        <App />
      </OverlayProvider>
    </BrowserRouter>
  </StrictMode>,
);
